"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import useUIStore from "@/shared/stores/ui/store";
import { TermModalType } from "@/shared/types/type/terms";
import { TermModal } from "@/shared/ui/templates";
const FotterTerm = () => {
  const $ = _c(44);
  const t = useTranslations();
  const {
    isTermModalOpen,
    termModalType,
    setIsTermModalOpen
  } = useUIStore();
  let t0;
  if ($[0] !== t) {
    t0 = type => {
      switch (type) {
        case "PRIVACY_POLICY":
          {
            return t("privacyPolicyTerms");
          }
        case "USING_SERVICE":
          {
            return t("serviceTerms");
          }
        case "LOCATION_BASED_SERVICE":
          {
            return t("locationBasedServiceTerms");
          }
        default:
          {
            return "";
          }
      }
    };
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getTermModalTitle = t0;
  let t1;
  if ($[2] !== setIsTermModalOpen) {
    t1 = (e, termType) => {
      e.preventDefault();
      setIsTermModalOpen(true, termType);
    };
    $[2] = setIsTermModalOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleTermClick = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      "--fs": 12,
      "--lh": 16
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== handleTermClick) {
    t3 = e_0 => handleTermClick(e_0, "PRIVACY_POLICY");
    $[5] = handleTermClick;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("privacyPolicyTerms");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <li><a href="/terms/privacy-policy.html" onClick={t3} className="underline cursor-pointer">{t4}</a></li>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== handleTermClick) {
    t6 = e_1 => handleTermClick(e_1, "USING_SERVICE");
    $[12] = handleTermClick;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("serviceTerms");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <li><a href="/terms/using-service.html" onClick={t6} className="underline cursor-pointer">{t7}</a></li>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== handleTermClick) {
    t9 = e_2 => handleTermClick(e_2, "LOCATION_BASED_SERVICE");
    $[19] = handleTermClick;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("locationBasedServiceTerms");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = <li><a href="/terms/location-based-service.html" onClick={t9} className="underline cursor-pointer">{t10}</a></li>;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t5 || $[28] !== t8) {
    t12 = <nav className="mb-[10px]"><ul className="fs flex items-center justify-start gap-4 text-[#46474C] font-medium underline-offset-[3px]" style={t2 as React.CSSProperties}>{t5}{t8}{t11}</ul></nav>;
    $[26] = t11;
    $[27] = t5;
    $[28] = t8;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== setIsTermModalOpen || $[31] !== termModalType) {
    t13 = () => setIsTermModalOpen(false, termModalType as TermModalType);
    $[30] = setIsTermModalOpen;
    $[31] = termModalType;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  const t14 = termModalType as TermModalType;
  const t15 = termModalType as TermModalType;
  let t16;
  if ($[33] !== getTermModalTitle || $[34] !== t15) {
    t16 = getTermModalTitle(t15);
    $[33] = getTermModalTitle;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== isTermModalOpen || $[37] !== t13 || $[38] !== t14 || $[39] !== t16) {
    t17 = <TermModal open={isTermModalOpen} onClose={t13} term={t14} termTitle={t16} />;
    $[36] = isTermModalOpen;
    $[37] = t13;
    $[38] = t14;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t12 || $[42] !== t17) {
    t18 = <>{t12}{t17}</>;
    $[41] = t12;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
};
export default FotterTerm;